import { render, staticRenderFns } from "./ConnectFeature.vue?vue&type=template&id=5f80322e&scoped=true&"
import script from "./ConnectFeature.vue?vue&type=script&lang=js&"
export * from "./ConnectFeature.vue?vue&type=script&lang=js&"
import style0 from "./ConnectFeature.vue?vue&type=style&index=0&id=5f80322e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80322e",
  null
  
)

export default component.exports